import { Subject } from 'rxjs';

export enum CalendarSubChromeEventType {
    newEvent
}

export class CalendarSubChromeConfig {
    events$: Subject<{ type: CalendarSubChromeEventType, payload?: any }>;
}
